@import "../../scss";

.root {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  padding: var(--spacer-4);

  @include media-breakpoint-down("md") {
    padding: var(--spacer-2);
  }
}

.root--visible {
  pointer-events: all;
}

.root:empty {
  display: none;
}

.shim {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
  pointer-events: none;
}

.shim--visible {
  opacity: 1;
  pointer-events: all;
}

.close {
  flex-shrink: 0;
  position: relative;
  margin-top: var(--spacer-2);
}

.plant-modal-transition {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 100%;
  transform-style: preserve-3d;
  perspective: 800px;
  position: absolute;
  padding: var(--spacer-4);

  @include media-breakpoint-down("md") {
    padding: var(--spacer-2);
  }

  @media (hover: none) {
    transform-style: unset;
  }
}

.plant-modal-transition:global(.enter) {
  will-change: transform, opacity;
  transition: all 0.8s cubic-bezier(0.16, 1, 0.3, 1);
  transform: translateY(100%);
  opacity: 0;
  z-index: 1;
}

.plant-modal-transition:global(.enter-active) {
  transform: translateY(0);
  opacity: 1;
}

.plant-modal-transition--biome:global(.enter) {
  will-change: transform, opacity;
  transition-delay: 0.3s;
  transition-duration: 1.2s;
  transform: scale(0.3);
}

.plant-modal-transition--biome:global(.enter-active) {
  transform: scale(1);
}

.plant-modal-transition:global(.exit) {
  transition: all 0.35s cubic-bezier(0.55, 0, 1, 0.45);
  transform: translateY(100%);
  opacity: 0;
}
